// services/api.js
import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_PATH || 'https://localhost:5001/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

export const priceComparisonApi = {
  comparePrices: (data) => api.post('PriceComparison/compare', data),
  getItemTypes: () => api.get('PriceComparison/itemtypes'),
  getTreatments: () => api.get('PriceComparison/treatments'),
};

export default api;
